
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/getting-started/example-github-repo",
      function () {
        return require("private-next-pages/getting-started/example-github-repo.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/getting-started/example-github-repo"])
      });
    }
  